import { Hammer, Gem, Ruler, Sparkles } from "lucide-react";
import { Reveal, ChapterHead } from "./shared";

const FEATURES = [
  {
    icon: Gem,
    title: "7 Crystal Stones",
    text: "Seven natural stone colours, from white at the crown to red at the root.",
    testid: "showcase-card-stones",
  },
  {
    icon: Hammer,
    title: "Handcrafted Design",
    text: "Every branch shaped and arranged by hand, stone by stone.",
    testid: "showcase-card-handcrafted",
  },
  {
    icon: Ruler,
    title: "Approx. 30 cm",
    text: "A considered size for shelves, desks and quiet corners.",
    testid: "showcase-card-size",
  },
  {
    icon: Sparkles,
    title: "Unique Decorative Piece",
    text: "Natural variation in the stones makes every tree one of one.",
    testid: "showcase-card-unique",
  },
];

export default function MoreThanDecor() {
  return (
    <section className="py-20 lg:py-32" data-testid="more-than-decor-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-16">
          <div className="lg:col-span-5">
            <ChapterHead number="01" label="Introduction" title="More Than Décor" testid="intro" />
          </div>
          <Reveal delay={0.15} className="lg:col-span-7">
            <p className="text-base sm:text-lg text-[#1A201C]/70 leading-relaxed max-w-2xl" data-testid="intro-text">
              The 7 Chakra Gemstone Tree brings together natural gemstone chips,
              handcrafted branches and symbolic colour into a distinctive decorative
              piece designed to add character and intention to your surroundings.
            </p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {FEATURES.map((f, i) => (
            <Reveal key={f.title} delay={i * 0.12}>
              <div
                className="group relative overflow-hidden h-full p-8 lg:p-10 border border-[#1B1915]/12 bg-white/50 rounded-sm hover:-translate-y-1.5 hover:border-[#1B1915]/30 hover:bg-white transition-[transform,border-color,background-color] duration-500"
                data-testid={f.testid}
              >
                <span className="absolute top-4 right-6 font-serif-display italic text-6xl text-[#1B1915]/[0.06] select-none">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <f.icon
                  className="w-6 h-6 text-[#2C2822] mb-8 group-hover:text-[#1B1915] transition-colors duration-300"
                  strokeWidth={1.5}
                />
                <h3 className="font-serif-display text-xl sm:text-2xl text-[#1B1915] mb-3 tracking-tight">
                  {f.title}
                </h3>
                <p className="text-sm sm:text-base text-[#1A201C]/65 leading-relaxed">{f.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
